import axios from "axios";
import { __constants } from "../../constants";
import { apiResponse } from "../../utils";
import { getUsersByConceirge } from "../Concierge";
import moment from "moment"
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const queryGenerator = (param) => {
    let query = "";
    if (param.query) { query += `&query=${param.query}` }
    if (param.page) { query += `&page=${param.page}` };
    if (param.fStatus === "Active") { query += `&fStatus=Active` };
    if (param.fStatus === "Inactive") { query += `&fStatus=Inactive` };
    if (param.fStatus === "Sleeping") { query += `&fStatus=Sleeping` };
    if (param.sName) { query += `&sName=1` };
    if (param.sAddedOn) { query += `&sAddedOn=1` };
    if (param.fCity) { query += `&fCity=${param.fCity}` };
    if (param.fStartDate) { query += `&fStartDate=${param.fStartDate}` };
    if (param.fEndDate) { query += `&fEndDate=${param.fEndDate}` };
    if (param.fPaymentOnboarding) { query += `&fPaymentOnboarding=${param.fPaymentOnboarding}` };

    /* For review filter */
    if (param.sByName) { query += `&sByName=${param.sByName}` };
    if (param.sByEmail) { query += `&sByEmail=${param.sByEmail}` };
    if (param.sByPosted) { query += `&sByPosted=${param.sByPosted}` };
    if (param.sByRating) { query += `&sByRating=${param.sByRating}` };
    if (param.fRating) { query += `&fRating=${param.fRating}` };
    if (param.fRole) { query += `&fRole=${param.fRole}` };
    if (param.id) { query += `&id=${param.id}` };

    return query;
}

export const updateUserStatus = async (id, status) => {
    try {
        const data = JSON.stringify({
            "userId": id,
            "status": status
        })

        const config = {
            method: 'PUT',
            url: BASE_URL + `/v1/admin/user-management/update-account-status`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
                'content-type': 'application/json'
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getBabySitterProfileController >> ", err.message);
        return err.response
    }
}

export const updateIdVerifiedBadge = async (id, verified) => {
    try {
        const data = JSON.stringify({
            "userId": id,
            "verified": verified
        })

        const config = {
            method: 'PUT',
            url: BASE_URL + `/v1/admin/user-management/update-identity-verified-badge`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
                'content-type': 'application/json'
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in updateIdVerifiedBadge >> ", err.message);
        return err.response
    }
}

export const getAllReviewsController = async (userId) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/common/user-review?userId=${userId}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getBabySitterProfileController >> ", err.message);
        return err.response
    }
}

export const getReviewListing = async (param) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/user-management/review?limit=${__constants.listingLimit}${queryGenerator(param)}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const approveRejectReviews = async (data) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + `/v1/admin/user-management/review-status`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}


export const deleteUser = async (userId) => {
  try {
    const config = {
      method: "DELETE",
      url: `${BASE_URL}/v1/admin/user-management/permanent-remove/${userId}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(__constants.authToken)}`,
      },
    }
    const response = await axios(config)
    return response
  } catch (err) {
    console.error("Error in deleteSeeker >> ", err.message)
    return err.response
  }
}
